import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { LlExamService } from '../ll-exam.service';
import { LlScrollpaneService } from '../ll-scrollpane.service';
import { LlPermissionsService } from '../ll-permissions.service';
import { jqxPanelComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxpanel'
import { jqxPopoverComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxpopover";
import { jqxTextAreaComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxtextarea";
import { fromEvent } from 'rxjs';
import { filter } from "../utility-search";
import { removeCarriageReturn } from "../utility";


@Component({
  selector: 'll-exam-sections-sp',
  templateUrl: './ll-exam-sections-sp.component.html',
  styleUrl: './ll-exam-sections-sp.component.css'
})
export class LlExamSectionsSpComponent {

  @ViewChild('mainDiv_ll_exam_sections_sp') mainDiv: ElementRef;
  @ViewChild('vertTab_ll_exam_sections_sp') private vertTab: ElementRef;
  @ViewChild('scrollpane_ll_exam_sections_sp') private SP: jqxPanelComponent;

  constructor(
    private LlExamService: LlExamService,
    private LlScrollpaneService: LlScrollpaneService,
    private LlPermissionsService: LlPermissionsService,

  ) { }

  bundle = {
    lable: "Sections",
    prefix: "SX",
    selectedId: -1,
    selectedId_ondeck: -1,
    //showObj: false,
    showObj: true,
    showRemaining: false,
    scrolling: false,
    canAdd: false,
    canDelete: false,
    canEdit: false,
    canFilter: true,

    addOrRemove: '',

    searchText: "",
    function: '',
    LlExamService: this.LlExamService,
    records: [],
    origionalRecords: [],
    parentW: 0,
    parentH: 0,
    remainingX: 0,
    remainingY: 0,
    remainingW: 0,
    remainingH: 0,
    SPYPosition: 0,
    ctx: {},
    showTab: true,
    objH: 0,
    lblY: 20,
    topOffset: 0,
    spY: 0,
    spW: 125,
    spH: 0,
    spB: 0,
    lineWidth: 1,
    vertLineX: 0,
    vertLineY: -1,
    vertLineW: 20,
    vertLineH: 0,
    tabY: 0,
    tabW: 0,
    tabH: 18,
    Tooltip01: 'not Found',

  }

  ngOnInit() { }

  eventSubscription_renewVisits: any;

  ngOnDestroy() {
    this.eventSubscription_renewVisits.unsubscribe();
  }

  ngAfterViewInit() {

    fromEvent(this.mainDiv.nativeElement, 'mousemove')
      .subscribe(res => {
        let value = this.SP.getVScrollPosition();

        if (value != this.bundle.SPYPosition) {
          this.bundle.SPYPosition = value;

          this.bundle.scrolling = true;

          document.getElementById(this.bundle.prefix + this.bundle.selectedId.toString()).click();
        }
      }
      );

    fromEvent(this.mainDiv.nativeElement, 'wheel')
      .subscribe(res => {
        let value = this.SP.getVScrollPosition();

        if (value != this.bundle.SPYPosition) {
          this.bundle.SPYPosition = value;

          this.bundle.scrolling = true;

          document.getElementById(this.bundle.prefix + this.bundle.selectedId.toString()).click();
        }
      }
      );


    this.setVars();
  }

  setVars() {

    //console.log("setVars()")

    this.bundle.function = this.mainDiv.nativeElement.parentElement.id;

    //console.log("this.bundle.function: " + this.bundle.function)

    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

    setTimeout(() => {

      this.LlScrollpaneService.standardDimentions(this.bundle);

      var canvasEl: HTMLCanvasElement = this.vertTab.nativeElement;
      canvasEl.width = this.bundle.vertLineX + this.bundle.vertLineW;
      canvasEl.height = this.bundle.vertLineH;
      this.bundle.ctx = canvasEl.getContext('2d');

      setTimeout(() => {
        this.LlScrollpaneService.standardRemainderValues(this.bundle, canvasEl);

        this.getData();
      });
    });
  }


  getData() {

    this.LlExamService.NG_LL_model_exam_sectionList_get((arr: any[]) => {

      this.bundle.records = arr || [];
      this.bundle.origionalRecords = arr || [];

      console.log(arr)

      let selectedId_initial = 0;

      if (this.bundle.records.length > 0) {
        selectedId_initial = this.bundle.records[0].FOLDERID;
      }

      setTimeout(() => {

        this.bundle.showObj = true;

        setTimeout(() => {

          if (selectedId_initial != null && document.getElementById(this.bundle.prefix + selectedId_initial.toString()) != null) {
            document.getElementById(this.bundle.prefix + selectedId_initial.toString()).click();
          }

        });
      });


    });

  }

  select(event) {


    this.bundle = this.LlScrollpaneService.bundle(event, this.bundle, this.SP)

    this.LlScrollpaneService.paintVertTab(this.bundle);

    if (this.bundle.scrolling == true) {

      this.bundle.scrolling = false;

    } else {

      this.bundle.showRemaining = false;

      setTimeout(() => {

        this.bundle.selectedId = this.bundle.selectedId_ondeck;
        this.LlExamService.setActiveSYSTEMPRODUCTSECTIONID(this.bundle.selectedId);

        this.bundle.showRemaining = true;
      });
    }
  }










}


